import { useEffect, useState } from "react";
import { Checkbox, ComboBox, DefaultButton, Dialog, DialogType, IComboBoxOption, IconButton, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import styles from '../styles/pokemon.module.scss';
import { TSet, TTag } from "../constants/types";

export interface IEditTagsProps {
    set: TSet;
    setMessage: Function;
    setError: Function;
    token: string;
    username: string;
    site: string;
    apiUrl: string;
}

const EditProps : React.FunctionComponent<IEditTagsProps> = (props : IEditTagsProps) => {
    const [length, setlength] = useState<number>(100);
    const [width, setwidth] = useState<number>(100);
    const [height, setheight] = useState<number>(50);
    const [weight, setweight] = useState<number>(200);
    const [showProps, setshowProps] = useState<boolean>(true);

    useEffect(() => {
        if (props.set) {
            const [l,w,h,we] = props.set.defaultlwhw.split(',');
            setlength(Number(l));
            setwidth(Number(w));
            setheight(Number(h));
            setweight(Number(we));
        }
    },[props.set]);

    function canSave() : boolean { 
        return cLWHWString() !== props.set.defaultlwhw;
    }

    function cLWHWString() : string {
        return `${length},${width},${height},${weight}`
    }

    function save() {
        let formData = new FormData();
        formData.append("defaultlwhw", cLWHWString());
        formData.append("defaulttags", props.set.defaulttags);
        formData.append("id", props.set.id.toString());
        formData.append("name", props.set.name);
        formData.append("parentid", props.set.parentid ? props.set.parentid.toString() : '0');
        formData.append("token",props.token);
        formData.append("username",props.username);
        formData.append("site",props.site);
        fetch(`${props.apiUrl}/UpdateSet`, {
            method: "Put",
            mode: "cors",
            referrerPolicy: "origin-when-cross-origin",
            body: formData
            }).then((response) => response.json()).then((data: number) => {
                props.setMessage("Standaard product eigenschappen opgeslagen");
            }).catch(err => {
                console.log(err);
                props.setError("Fout tijdens opslaan van standaard product eigenschappen. "+err);
        });
    }

    return (
        props.set ? 
            <Stack horizontal style={{marginLeft:0, display: window.innerWidth > 950 ? "flex":"block"}}>
                <Stack style={{height:"100%", margin:5, border:"1px solid blue", padding: 5}} >
                    <Stack horizontal onClick={() => {setshowProps(!showProps)}} verticalAlign='center' >
                        <IconButton iconProps={{iconName: showProps ? 'Hide' : "View"}} />
                        &nbsp;
                        <Label style={{fontWeight:"bold", cursor:"pointer"}}>Standaard product eigenschappen</Label>
                    </Stack>
                    {showProps && <Stack horizontalAlign='start'>
                                    <TextField label={"Lengte" } type="number" value={length.toString()} styles={{root: {width: '100%'}}} suffix="millimeter" onChange={(e,v) => {setlength(Number(v));}}/>
                                    <TextField label={"Breedte"} type="number" value={width.toString()} styles={{root: {width: '100%'}}} suffix="millimeter" onChange={(e,v) => {setwidth(Number(v));}}/>
                                    <TextField label={"Hoogte"} type="number" value={height.toString()} styles={{root: {width: '100%'}}} suffix="millimeter" onChange={(e,v) => {setheight(Number(v));}}/>
                                    <TextField label={"Gewicht"} type="number" value={weight.toString()} styles={{root: {width: '100%'}}} suffix="gram" onChange={(e,v) => {setweight(Number(v));}}/>
                                    <Stack horizontalAlign="end" style={{width:"100%",paddingTop:5}}>
                                        <PrimaryButton disabled={!canSave()} text="Opslaan" onClick={save} />
                                    </Stack>
                                </Stack>}
                </Stack>
            </Stack>
        : <></>
    );
}

export default EditProps;